import React from "react";

import {
  highSeverities,
  injuryOutcomes,
  severities,
  STAFFEMPLOYER,
} from "../../CONSTANTS";
import { Button, Col, Row } from "react-bootstrap";

import { ButtonsContainer } from "../../IncidentReportForm";
import FormInput from "app/Components/_form/FormInput/FormInput";

import YesOrNo from "app/_pages/_healthSafetyEnvironment/YesOrNo.component";
import Srcollbar from "react-perfect-scrollbar";
import { SearchableSelect } from "app/Components/SearchableSelect/SSingleSelect";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import Input from "app/Components/_form/Input/Input";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import { BsFillInfoCircleFill } from "react-icons/bs";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import { bodyLabel } from "app/Components/BodyPartComponent/CONSTANT";
import { getArraayofKeys } from "../../Helper";
import MultiSelectTwo from "app/Components/SearchableSelect/MultiSelectTwo";

const BODY_PART_LIST = [
  ...Object.keys(bodyLabel).map((d) => ({ label: bodyLabel[d], value: d })),
];

function PersonnelDetailsTab({
  form = {},
  onChange,
  error = {},
  setTab,
  onSubmit,
  personalDetails,
  onChangePersonalDetails,
  personalDetailsErrors,
  onChangePersonalDetailsEmployee,
  deleteRowPersonalDetails,
  addRowPersonalDetails,
  users,
  contractors,
  employeeList,
  contractorsStaff,
}) {
  return (
    <div className="card p-3 pb-0 mt-3 overflow-visible">
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">Personnel Details</h3>
      </div>
      <div className="ehsFormWrapper">
        <Row className="mb-4 justify-content-start align-items-center">
          <Col lg={4}>
            <YesOrNo
              title="Personal Affected"
              name="isPersonalInjury"
              value={form.isPersonalInjury === null ? false : form.isPersonalInjury}
              onChange={onChange}
            />
            <span className="small text-danger">{error?.isPersonalInjury}</span>
          </Col>
        </Row>
        <Row>
          {form.isPersonalInjury && (
            <Col lg={3}>
              {/* <label>Number of people involved</label>
              <input
                readOnly={!form.isPersonalInjury}
                name="peopleCount"
                value={form.peopleCount}
                onChange={(event) =>
                  event.target.value >= 0 &&
                  event.target.value <= 99999 &&
                  onChange(event)
                }
                type="number"
                className="form-control"
              />
              <span className="small text-danger">{error?.peopleCount}</span> */}

              <FormInput
                readOnly={!form.isPersonalInjury}
                name="peopleCount"
                value={form.peopleCount}
                onChange={(event) =>
                  event.target.value >= 0 &&
                  event.target.value <= 99999 &&
                  onChange(event)
                }
                type="number"
                label={"Number of people involved"}
                error={error?.peopleCount}
              />
            </Col>
          )}
        </Row>
        {form.isPersonalInjury && (
          <div className="w-100">
            <div className="table-responsive drillingPlan-plannedEdit">
              <Srcollbar className="workoverCategoryScroll">
                <table className="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th
                        scope="col"
                        colSpan="5"
                        className="text-center personnelDetails"
                      >
                        Personnel Details
                      </th>
                      <th scope="col" colSpan="5" className="text-center injuryDetails">
                        Injury/Illness Details
                      </th>
                      <th scope="col"></th>
                    </tr>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col" style={{ minWidth: 180 }}>
                        Type
                      </th>
                      <th scope="col" style={{ minWidth: 230 }}>
                        Name
                      </th>
                      <th scope="col" style={{ minWidth: 180 }}>
                        Employer
                      </th>
                      <th scope="col" style={{ minWidth: 80 }}>
                        ID
                      </th>
                      {/* <th scope="col" className="w-150">
                        Phone
                      </th> */}
                      <th
                        scope="col"
                        style={{ minWidth: 80, borderRight: "3px solid #dee2e6" }}
                      >
                        Age
                      </th>
                      <th scope="col" style={{ maxWidth: "165px", minWidth: "165px" }}>
                        Type
                      </th>
                      <th scope="col" style={{ maxWidth: "120px", minWidth: "120px" }}>
                        Severity{" "}
                        <CustomPopover
                          placement={"left"}
                          tooltip={
                            <>
                              <table className="table table-bordered mb-0 tooltipTable">
                                <thead>
                                  <tr>
                                    <th>Severity</th>
                                    <th>Description</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {highSeverities.map((x) => {
                                    return (
                                      <tr>
                                        <td>{x.label}</td>
                                        <td>{x.tooltip}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </>
                          }
                        >
                          <BsFillInfoCircleFill />
                        </CustomPopover>
                      </th>
                      <th scope="col" style={{ maxWidth: "165px", minWidth: "165px" }}>
                        Body Parts Involved
                      </th>
                      <th scope="col" style={{ maxWidth: "160px", minWidth: "160px" }}>
                        Outcome
                      </th>
                      <th scope="col" style={{ minWidth: 120 }}>
                        LTI Hours
                      </th>
                      <th scope="col">Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {personalDetails.length ? (
                      personalDetails.map((x, index) => {
                        return x.deleted ? null : (
                          <tr key={index}>
                            <th>{index + 1}</th>
                            <td>
                              <SearchableSelect
                                name="type"
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.type}
                                options={["Employee", "Contractor", "Others"]}
                                init="none"
                                array="single"
                              ></SearchableSelect>
                            </td>
                            <td>
                              {x.type === "Employee" ? (
                                <SearchableSelect
                                  options={employeeList.map((employee) => ({
                                    label: employee.name_email_employeeId,
                                    value: employee.id,
                                    optionDetails: employee,
                                  }))}
                                  value={x.userId}
                                  onChange={({
                                    target: { label, value, optionDetails },
                                  }) => {
                                    onChangePersonalDetailsEmployee(
                                      index,
                                      optionDetails.name_email_employeeId,
                                      optionDetails.id,
                                      //optionDetails.contactNumber,
                                      optionDetails.dob
                                    );
                                  }}
                                  placeholder={"Search by Name / Email Id / Employee Id"}
                                  blankSelect={"none"}
                                />
                              ) : x.type === "Contractor" ? (
                                <SearchableSelect
                                  options={contractorsStaff.map((staff) => ({
                                    label: staff.name_aadharNumber_srNo,
                                    value: staff.id,
                                    optionDetails: staff,
                                  }))}
                                  value={x.userId}
                                  onChange={({
                                    target: { label, value, optionDetails },
                                  }) => {
                                    onChangePersonalDetailsEmployee(
                                      index,
                                      optionDetails.name_aadharNumber_srNo,
                                      optionDetails.id,
                                      //optionDetails.phoneNumber,

                                      optionDetails.dob
                                    );
                                  }}
                                  placeholder={"Search by Name / Aadhar No / Sr No."}
                                  blankSelect={"none"}
                                />
                              ) : (
                                <Input
                                  name="name"
                                  type="text"
                                  onChange={({ target: { name, value } }) =>
                                    onChangePersonalDetails(index, name, value)
                                  }
                                  value={x.name}
                                  className="form-control"
                                />
                              )}
                              <span className="small text-danger">
                                {personalDetailsErrors[index]?.name}
                              </span>
                            </td>
                            <td>
                              <FormSelect
                                name="employer"
                                value={x.type === "Contractor" ? +x.employer : x.employer}
                                options={
                                  x.type === "Contractor" ? contractors : STAFFEMPLOYER
                                }
                                KEY_label={
                                  x.type === "Contractor"
                                    ? "contractorLegalEntity"
                                    : "contactPerson"
                                }
                                KEY_value={"id"}
                                blankSelect={"Select"}
                                disabled={true}
                              ></FormSelect>
                            </td>
                            <td>
                              <Input
                                name="userId"
                                type="text"
                                value={x.userId || ""}
                                className="form-control"
                                disabled
                              />
                            </td>
                            {/* <td>
                              <Input
                                name="phone"
                                type="number"
                                onChange={({ target: { name, value } }) =>
                                  value >= 0 &&
                                  value <= 9999999999 &&
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.phone}
                                className="form-control"
                                error={personalDetailsErrors[index]?.phone}
                              />
                              <span className="small text-danger">
                                {personalDetailsErrors[index]?.phone}
                              </span>
                            </td> */}
                            <td style={{ borderRight: "3px solid #dee2e6" }}>
                              <Input
                                name="age"
                                type="number"
                                onChange={({ target: { name, value } }) =>
                                  value >= 0 &&
                                  value <= 200 &&
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.age}
                                className="form-control"
                                // error={personalDetailsErrors[index]?.age}
                              />
                              <span className="small text-danger">
                                {personalDetailsErrors[index]?.age}
                              </span>
                            </td>
                            <td>
                              <SearchableSelect
                                name="injuryType"
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.injuryType}
                                options={[
                                  "Not Applicable",
                                  "Unknown",
                                  "Blowout",
                                  "Burn",
                                  "Cardiac Arrest",
                                  "Driving",
                                  "Electrocution",
                                  "Explosion",
                                  "Fall",
                                  "Fever",
                                  "Fracture",
                                  "Gas Inhalation",
                                  "Pain",
                                  "People Conflict",
                                  "Respiratory",
                                  "Slip/Trip",
                                  "Vehicle Accident",
                                  "Unconsciousness",
                                  "Vomiting",
                                ]}
                                init="none"
                                array="single"
                              ></SearchableSelect>
                            </td>
                            <td>
                              <SearchableSelect
                                name="severity"
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.severity}
                                options={Object.keys(severities)}
                                object={severities}
                                init="none"
                                disabled={x.injuryType === "Not Applicable"}
                              ></SearchableSelect>
                            </td>
                            <td>
                              {/* <FormSelect
                                name="bodyParts"
                                value={x.bodyParts}
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                options={getArraayofKeys({
                                  notApplicable: "Not Applicable",
                                  unknown: "Unknown",
                                  ...bodyLabel,
                                })}
                                object={{
                                  notApplicable: "Not Applicable",
                                  unknown: "Unknown",
                                  ...bodyLabel,
                                }}
                              ></FormSelect> */}
                              <MultiSelectTwo
                                options={BODY_PART_LIST.map((d) => ({
                                  ...d,
                                  disabled:
                                    d.value === "notApplicable" &&
                                    x?.bodyParts === "notApplicable"
                                      ? false
                                      : x?.bodyParts === "Not Applicable" ||
                                        !x?.bodyParts ||
                                        x?.bodyParts !== "notApplicable"
                                      ? false
                                      : true,
                                }))}
                                value={x?.bodyParts
                                  ?.split(",")
                                  .map((id) => {
                                    const found = BODY_PART_LIST.find(
                                      (site) => site.value === id
                                    );

                                    return found || null;
                                  })
                                  .filter((d) => !!d)}
                                onChange={(selectedSites) => {
                                  onChangePersonalDetails(
                                    index,
                                    "bodyParts",
                                    selectedSites?.map((site) => site.value).join(",")
                                  );
                                }}
                                hasSelectAll={false}
                                isDisabled={x.injuryType === "Not Applicable"}
                              />
                              {/* <SearchableSelect
                                name="bodyParts"
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.bodyParts}
                                options={[
                                  "Not Applicable",
                                  "Unknown",
                                  "Arms",
                                  "Abdomen",
                                  "Chest",
                                  "Ears",
                                  "Eyes",
                                  "Face",
                                  "Feet",
                                  "Fingers",
                                  "Genitals",
                                  "Hands",
                                  "Head",
                                  "Internal Injury",
                                  "Knee",
                                  "Legs",
                                  "Mouth",
                                  "Neck",
                                  "Nose",
                                  "Spine",
                                  "Toes",
                                ]}
                                init="none"
                                array="single"
                              ></SearchableSelect> */}
                            </td>
                            <td>
                              {/* <select
                                className="form-control"
                                name="outcome"
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.outcome}
                              >
                                {Object.keys(injuryOutcomes).map((key) => (
                                  <option key={key} value={injuryOutcomes[key]}>
                                    {injuryOutcomes[key]}
                                  </option>
                                ))}
                              </select> */}

                              <SearchableSelect
                                name="outcome"
                                onChange={({ target: { name, value } }) =>
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.outcome}
                                options={Object.keys(injuryOutcomes)}
                                object={injuryOutcomes}
                                disabled={x.injuryType === "Not Applicable"}
                              />
                            </td>
                            <td>
                              <Input
                                name="ltiHours"
                                type="number"
                                onChange={({ target: { name, value } }) =>
                                  value >= 0 &&
                                  value <= 999999 &&
                                  onChangePersonalDetails(index, name, value)
                                }
                                value={x.ltiHours}
                                className="form-control"
                                readOnly={x.outcome !== "lostTime"}
                              />
                              <span className="small text-danger">
                                {personalDetailsErrors[index]?.ltiHours}
                              </span>
                            </td>
                            <td>
                              <div className="actionIconsGroup">
                                {/* <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">Delete</Tooltip>
                                  }
                                >
                                  <a
                                    href
                                    className="icons text-danger pointer font-20"
                                    onClick={() =>
                                      deleteRowPersonalDetails(index)
                                    }
                                  >
                                    <FiMinusCircle />
                                  </a>
                                </OverlayTrigger> */}
                                <CustomTooltip tooltip="Delete">
                                  <a
                                    href
                                    className="icons text-danger pointer font-20"
                                    onClick={() => deleteRowPersonalDetails(index)}
                                  >
                                    <FiMinusCircle />
                                  </a>
                                </CustomTooltip>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" align="center">
                          {/* <div className="alert alert-danger d-inline-block m-0">
                                                                <strong>Empty</strong>
                                                            </div> */}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td colSpan="12">
                        {/* <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                        >
                          <Button
                            className="addRowPluseIcon"
                            onClick={addRowPersonalDetails}
                          >
                            <FiPlusCircle />
                          </Button>
                        </OverlayTrigger> */}
                        <CustomTooltip tooltip="Add Row">
                          <Button
                            className="addRowPluseIcon"
                            onClick={addRowPersonalDetails}
                          >
                            <FiPlusCircle />
                          </Button>
                        </CustomTooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Srcollbar>
            </div>
          </div>
        )}
      </div>
      <ButtonsContainer
        incidentStatus={form.incidentStatus}
        setTab={setTab}
        prev={2}
        next={4}
        closeIncident={form.closeIncident}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default PersonnelDetailsTab;
